import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios-instance";

export const fetchProfileStatus = createAsyncThunk(
    "profile/fetchProfileStatus",
    async () => {
        try {
            const response = await axiosInstance({
                method: "get",
                url: "/profileStatus"
            });
            return response.data.data;
        } catch (error) {
            console.error(error);
            return Promise.reject(error);
        }
    }
);
